import React from "react"
import { connect } from "react-redux"
import styled, { css } from "styled-components"
import { responsive, colors } from "buoy-theme"
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup"
import { Waypoint } from "react-waypoint"
import {
  setDiagnosisAgreement,
  setDiagnosisHelpfulness,
  setShowTipModal,
  setShowFollowUpModal,
  setShowFollowUpCard,
} from "./actions"
import { initPayment, initIntellivisit } from "../payment/actions"
import { showPostIntentPopUp } from "../feedback/actions"
import Diagnosis from "./components/Diagnosis"
import Alarm from "./components/Alarm"
import AlarmRecommendationSection from "./components/AlarmRecommendationSection"
import Learning from "../feedback/components/Learning"
import CardContainer from "./components/Card"
import UserSatisfaction from "../feedback/components/UserSatisfaction"
import ZipcodeInput from "./components/ZipcodeInput"
import TipModal from "../payment/components/TipModal"
import FollowUpModal from "./components/FollowUpModal"
import ProfileInterestInput, {
  getProfileInterestAbOption,
} from "./components/ProfileInterestInput"
import postIntent from "../integration/postIntent"
import tracker from "../common/tracker"
import { IS_PRODUCTION, STATIC_URL } from "../common/constants"
import RecommendationCard from "../common/components/RecommendationCard"
import NpsFeedback from "../feedback/components/nps/NpsFeedback"
import ScrollTracker from "../interview/components/ScrollTracker"

const RootContainer = styled.div`
  max-width: 640px;
  ${props =>
    props.isProfile
      ? css`
          margin-top: 32px;
        `
      : css`
          ${responsive("margin-top", "40px", "40px", "32px", "32px", "24px")};
        `};
`

const Container = styled(CardContainer)`
  width: auto;

  ${responsive(
    "box-sizing",
    "unset",
    "unset",
    "border-box",
    "border-box",
    "border-box"
  )};

  ${props =>
    props.isProfile
      ? css`
          ${responsive(
            "margin",
            "0 -32px 16px",
            "0 -32px 16px",
            "0 0 16px",
            "0 0 16px",
            "0 0 16px"
          )};
        `
      : css`
          ${responsive(
            "margin",
            "0 -32px 40px",
            "0 -32px 40px",
            "0 0 24px",
            "0 0 24px",
            "0 0 24px"
          )};
        `};

  ${props =>
    props.last && !props.isProfile
      ? responsive("margin-bottom", "40px", "40px", "32px", "32px", "32px")
      : ""};
`

const StyledZipcodeArea = styled.div`
  margin-bottom: 40px;
`

const AlarmContainer = styled(Container)`
  border-top: solid 2px
    ${props =>
      props.triageLevel >= 5 ? colors.landingRed : colors.landingYellow};
`

const displayFollowUpCard = (showFollowUpCard, setShowFollowUpModal) => {
  return (
    showFollowUpCard && (
      <ScrollTracker sectionTitle="Resource - follow up">
        <RecommendationCard
          borderColor={colors.primary}
          headline={`We’d like to check back in `}
          description={`Can Buoy text you in 3 days to see how you’re doing? `}
          ctaText={`Yes, check in`}
          showModal={setShowFollowUpModal}
          trackerEvent={() => tracker.followUpModalTriggered()}
          diagnosisCard
        />
      </ScrollTracker>
    )
  )
}

const displayNpsCard = (showNpsCard, getNpsFeedback, npsScore) => {
  let header = ""
  if (npsScore) header = `What is the main reason for your score?`
  else header = `How likely are you to recommend Buoy to a friend?`
  return (
    showNpsCard &&
    getNpsFeedback && (
      <RecommendationCard
        borderColor={colors.primary}
        headline={header}
        component={<NpsFeedback />}
        diagnosisCard
      />
    )
  )
}

class Completion extends React.Component {
  constructor() {
    super()
    this.repeatedPostIntentPopUp = false
  }

  render() {
    const {
      results,
      isAlarm,
      setDiagnosisAgreement,
      recommendationSections,
      setDiagnosisHelpfulness,
      brand,
      getNpsFeedback,
      isProfile,
      showTip,
      setShowTipModal,
      profileInterest,
      showPostIntentPopUp,
      initPayment,
      initIntellivisit,
      showFollowUpModal,
      showFollowUpCard,
      showNpsCard,
      npsScore,
      setShowFollowUpModal,
      setShowFollowUpCard,
      profiles,
      diagConcernRec,
      identifiers,
    } = this.props
    return (
      <RootContainer
        className="completion"
        id="completionContainer"
        isProfile={isProfile}
      >
        {!isProfile && !results.alarm && (
          <StyledZipcodeArea>
            <ZipcodeInput />
          </StyledZipcodeArea>
        )}
        {results && results.differential && !results.alarm ? (
          results.differential.map((d, i) => (
            <ScrollTracker
              key={d.token}
              sectionTitle={`diagnosis match ${i + 1}`}
            >
              <Container
                key={d.token}
                isProfile={isProfile}
                last={i + 1 === results.differential.length}
              >
                <Diagnosis
                  brand={brand}
                  diagnosis={d}
                  index={i}
                  total={results.differential.length}
                  recommendationSection={
                    recommendationSections &&
                    Object.keys(recommendationSections).length > 0 &&
                    recommendationSections[d.predictor_id]
                  }
                  showZip={
                    recommendationSections &&
                    recommendationSections.length > 0 &&
                    recommendationSections[d.predictor_id].show_zip
                  }
                  results={results}
                  setDiagnosisHelpfulness={setDiagnosisHelpfulness}
                  initPayment={initPayment}
                  initIntellivisit={initIntellivisit}
                />
              </Container>
              {i === 0 &&
                displayFollowUpCard(showFollowUpCard, setShowFollowUpModal)}

              {diagConcernRec &&
                i === 0 &&
                diagConcernRec.map((rec, i) => (
                  <ScrollTracker
                    key={rec.token}
                    sectionTitle={`Resource - DXoC ${i + 1}`}
                  >
                    <RecommendationCard
                      token={rec.token}
                      key={rec.recommendation}
                      ctaText={rec.ctaText}
                      ctaUrl={rec.ctaUrl}
                      highlights={rec.highlights}
                      infoList={rec.info}
                      tags={rec.tags}
                      headline={rec.headline}
                      description={rec.summary}
                      image={rec.image ? `${STATIC_URL}${rec.image}` : null}
                      requirePayment={rec.requirePayment}
                      requireProfile={rec.requireProfile}
                      diffToken={d.token}
                      initPayment={initPayment}
                      initIntellivisit={initIntellivisit}
                      rec={rec}
                      borderColor={colors.primary}
                      diagnosisCard
                    />
                  </ScrollTracker>
                ))}
              {displayNpsCard(showNpsCard, getNpsFeedback, npsScore)}
              {!getNpsFeedback &&
                IS_PRODUCTION &&
                (results.differential.length === 1 || i === 1) && (
                  <Waypoint
                    onEnter={() => {
                      setTimeout(() => {
                        if (!this.repeatedPostIntentPopUp && !getNpsFeedback) {
                          showPostIntentPopUp(true)
                          tracker.postIntentPopUpShown()
                          this.repeatedPostIntentPopUp = true
                        }
                      }, postIntent.timeout)
                    }}
                    scrollableAncestor={window}
                  />
                )}
            </ScrollTracker>
          ))
        ) : (
          <React.Fragment>
            <AlarmContainer triageLevel={results.triage.level}>
              <Alarm triage={results.triage} identifiers={identifiers} />
            </AlarmContainer>
            {/* only displaying next care steps section for triage 2, 5, and 6 (subject to change) */}
            {[2, 5, 6].indexOf(results.triage.level) !== -1 ? (
              <Container>
                <AlarmRecommendationSection
                  initPayment={initPayment}
                  initIntellivisit={initIntellivisit}
                />
              </Container>
            ) : (
              <React.Fragment>
                {recommendationSections &&
                  recommendationSections.alarm &&
                  recommendationSections.alarm.map((rec, i) => (
                    <ScrollTracker
                      key={rec.token}
                      sectionTitle={`Resource - alarm ${i + 1}`}
                    >
                      <RecommendationCard
                        token={rec.token}
                        key={rec.recommendation}
                        ctaText={rec.ctaText}
                        ctaUrl={rec.ctaUrl}
                        highlights={rec.highlights}
                        infoList={rec.info}
                        tags={rec.tags}
                        headline={rec.headline}
                        description={rec.summary}
                        image={rec.image ? `${STATIC_URL}${rec.image}` : null}
                        requirePayment={rec.requirePayment}
                        requireProfile={rec.requireProfile}
                        diffToken={"alarm"}
                        initPayment={initPayment}
                        initIntellivisit={initIntellivisit}
                        rec={rec}
                        borderColor={colors.primary}
                        diagnosisCard
                      />
                    </ScrollTracker>
                  ))}
              </React.Fragment>
            )}
            <React.Fragment>
                {recommendationSections &&
                  recommendationSections.alarm_content &&
                  recommendationSections.alarm_content.map((rec, i) => (
                    <ScrollTracker
                      key={rec.token}
                      sectionTitle={`Resource - alarm content ${i + 1}`}
                    >
                      <RecommendationCard
                        token={rec.token}
                        key={rec.recommendation}
                        ctaText={rec.ctaText}
                        ctaUrl={rec.ctaUrl}
                        highlights={rec.highlights}
                        infoList={rec.info}
                        tags={rec.tags}
                        headline={rec.headline}
                        description={rec.summary}
                        image={rec.image ? `${STATIC_URL}${rec.image}` : null}
                        requirePayment={rec.requirePayment}
                        requireProfile={rec.requireProfile}
                        diffToken={"alarm"}
                        initPayment={initPayment}
                        initIntellivisit={initIntellivisit}
                        rec={rec}
                        borderColor={colors.primary}
                        diagnosisCard
                      />
                    </ScrollTracker>
                  ))}
              </React.Fragment>
            {displayFollowUpCard(showFollowUpCard, setShowFollowUpModal)}
            {displayNpsCard(showNpsCard, getNpsFeedback, npsScore)}
          </React.Fragment>
        )}
        {brand.name === "public" &&
          getProfileInterestAbOption() &&
          !profileInterest.submitted && (
            <ProfileInterestInput
              option={getProfileInterestAbOption()}
              profileInterest={profileInterest}
            />
          )}
        {brand.name !== "public" && !isProfile && (
          <ScrollTracker sectionTitle="rating feedback">
            <UserSatisfaction />
          </ScrollTracker>
        )}
        {!isProfile && !isAlarm && (
          <Learning
            differential={results.differential}
            setDiagnosisAgreement={setDiagnosisAgreement}
            isProfile={isProfile}
            first={brand.name === "public"}
          />
        )}
        {showFollowUpModal && (
          <FollowUpModal
            showModal={setShowFollowUpModal}
            showFollowUpCard={setShowFollowUpCard}
            profile={profiles}
          />
        )}
        <CSSTransitionGroup
          transitionName="simple-fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          {showTip && <TipModal showModal={setShowTipModal} />}
        </CSSTransitionGroup>
      </RootContainer>
    )
  }
}

const mapStateToProps = state => ({
  brand: state.brand,
  results: state.completion.results,
  isAlarm: state.completion.isAlarm,
  showTip: state.completion.showTipModal,
  profileInterest: state.completion.profileInterest,
  recommendationSections: state.integration.recommendationSections,
  getNpsFeedback: state.feedback.getNpsFeedback,
  showPostIntent: state.feedback.showPostIntentPopUp,
  showFollowUpModal: state.completion.showFollowUpModal.show,
  showFollowUpCard: state.completion.showFollowUpCard.show,
  showNpsCard: state.feedback.showNpsCard,
  npsScore: state.feedback.npsScore,
  profiles: state.account.profiles,
  diagConcern: state.feedback.diagnosisConcern,
  diagConcernRec: state.integration.diagnosisConcernRecommendations,
  identifiers: state.identifiers,
})

const mapDispatchToProps = {
  setDiagnosisAgreement,
  setDiagnosisHelpfulness,
  setShowTipModal,
  setShowFollowUpModal,
  setShowFollowUpCard,
  showPostIntentPopUp,
  initPayment,
  initIntellivisit,
}

export default connect(mapStateToProps, mapDispatchToProps)(Completion)



// WEBPACK FOOTER //
// ./assets/completion/index.js